import { Topic } from '@/@types/topic'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { CACHE_TOPICS_QUERY_OPTIONS } from '../fetchers/topic'

export default function useTopics(ids: string[]): Topic[] {
	const { data: allTopics } = useQuery(CACHE_TOPICS_QUERY_OPTIONS)
	return useMemo(() => {
		return ids.map((id) => allTopics?.[id]).filter((item) => !!item) as Topic[]
	}, [ids, allTopics])
}
